
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Dialog from '@/components/dialog.vue';
	import uploadImg from '@/components/upload-img.vue';
  import {
    orderExpressBroadcastimport,
    orderExpressBroadcastlist
  } from "@/api/order"
  import {
    getOssToken
  } from '@/api/user'
  @Component({  
    name: '',
    components: {
      PageFooter,
			'slz-dialog': Dialog,
			'upload-img': uploadImg,
    }
  })

  export default class ProductList extends Vue {
		private pageNo = 1;
		private pageSize =10;
		private total = 0;
    private keywords = ''
    private tablelist:any = []
    private tableloading = false
    private importShow = false
    private token:any = {}
    private filelist:any = []
    private filename = ''
    private mounted () {
      this.gettablelist()
    }

    private async handleConfirmImport(){
      if(!this.filelist||!this.filelist.length){
        this.$message.error('请选择上传文件')
        return
      }
      try{
        let res = await orderExpressBroadcastimport({
          ExcelFilePath:this.filelist[0],
          ExcelFileName:this.filename
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.close()
          this.gettablelist()
        }
      }finally{
        //
      }
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let res = await orderExpressBroadcastlist({
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }

      }finally{
        this.tableloading = false
      }
    }
    private close(){
      this.filelist = []
      this.filename = ''
      this.importShow = false
    }
    private uploadSuc(e,name,name2){
      // console.log(e,name2)
      this.filelist = e
      this.filename = name2
    }
    // 获取token
    private async getToken() {
      try {
        const res: any = await getOssToken({})
        this.token = {
          AccessKeySecret: res.access_key_secret,
          OSSAccessKeyId: res.access_key_id,
          SecurityToken: res.security_token
        }
      } catch (e) {
        console.error('getOssToken ===>', e)
      }
    }
  }
